import { createSelector } from '@reduxjs/toolkit';
import { SLACK_MESSAGES_STATUS, SLACK_SEND_STATUS } from 'utils/slackMessages';

const emptyArray = [];
const emptySlice = {
    messagesByTransactionId: {},
    dialogOpenByTransactionId: {},
    sendByTransactionId: {},
};

export const selectSlackSlice = (state) => state.slack || emptySlice;

const selectMessagesByTransactionId = createSelector([selectSlackSlice], (slack) => slack.messagesByTransactionId);
const selectDialogOpenByTransactionId = createSelector([selectSlackSlice], (slack) => slack.dialogOpenByTransactionId);
const selectSendByTransactionId = createSelector([selectSlackSlice], (slack) => slack.sendByTransactionId);

export const selectSlackMessagesStatusByTransactionId = (id) =>
    createSelector([selectMessagesByTransactionId], (messages) => messages[id]?.status || SLACK_MESSAGES_STATUS.IDLE);

export const selectSlackMessagesByTransactionId = (id) =>
    createSelector([selectMessagesByTransactionId], (messages) => messages[id]?.items || emptyArray);

export const selectSlackDialogOpenByTransactionId = (id) => createSelector([selectDialogOpenByTransactionId], (open) => !!open[id]);

export const selectSlackSendStateByTransactionId = (id) => createSelector([selectSendByTransactionId], (sends) => sends[id] || null);

export const selectSlackSendInProgressByTransactionId = (id) =>
    createSelector([selectSendByTransactionId], (sends) => sends[id]?.status === SLACK_SEND_STATUS.SENDING);
